import styled from "styled-components";

export const StyledBookingsContainer = styled.section`
  
`;
export const StyledBookingsContent = styled.div`
  background-color: #ffffff;
  min-height: ${({ headerHeight = 76 }) => `calc(100dvh - ${headerHeight}px - 66px)`};
`;
